import { useEffect } from 'react'

import { useSetState } from '@domain-group/react-hooks'

import useAdCopy from '@hooks/useAdCopy'
import useCampaign from '@hooks/useCampaign'

const defaultState = {
  dirty: false,
}

function useCampaignSync(campaignId: number) {
  const [state, setState] = useSetState(defaultState)
  const { dirty } = state

  const adCopyPayload = useAdCopy()
  const {
    updating,
  } = adCopyPayload

  const {
    callbacks: {
      portalSync,
    },
  } = useCampaign({ id: campaignId })

  useEffect(
    () => () => {
      if (dirty) portalSync()
    },
    [dirty],
  )

  useEffect(() => {
    if (updating) setState({ dirty: true })
  }, [updating])

  return {}
}

export default useCampaignSync
